import { createAsyncThunk } from "@reduxjs/toolkit";
import { i18nSliceName } from ".";
import { i18nSelectAction } from "./i18nSelectAction";

const languagesJson = require("../../../../config/langs/languages.json");

export const i18nInitAction = createAsyncThunk(`${i18nSliceName}/i18nInit`, async (_, thunkAPI) => {
  thunkAPI.dispatch(i18nSelectAction(languagesJson.find((lang) => lang.enable)));
  return languagesJson;
});
